import { useRepositories } from "../../../contexts";
import { useAppMutation } from "../utils";
export var useSignUpMutation = function () {
    var authRepo = useRepositories().authRepo;
    return useAppMutation(function (params) {
        return authRepo.signUp(params);
    });
};
